import useRequest from '@space-shell/common/hooks/useRequest'
import type { Toggles } from '@space-shell/common/services/toggle'
import { ToggleEndpoints, ToggleService } from '@space-shell/common/services/toggle'

type UseFeatureToggleParams = {
  toggleName: Toggles
  defaultValue?: boolean
  unleashId?: string
  options?: {
    enabled?: boolean
  }
}

/**
 * Hook to handle feature flag with Unleash.
 *
 * @param {Object} params - Parameters for the hook.
 * @param {string} params.toggleName - The name of the feature toggle.
 * @param {boolean} params.defaultValue - The default value of the feature toggle.
 * @param {string} params.unleashId - The ID used to identify the unleash instance.
 * @param {Object} [params.options] - Optional configuration for the hook.
 *
 */
const useFeatureToggle = ({
  toggleName,
  defaultValue,
  unleashId,
  options
}: UseFeatureToggleParams) => {
  return useRequest(
    [ToggleEndpoints.getFeatureToggle(toggleName)],
    () => ToggleService.getFeatureToggle(toggleName, defaultValue, unleashId),
    options
  )
}

export default useFeatureToggle
